
let  dsfsefdffx =
  "<div class=\"form-group\" ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false }\">" +
  "  <label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>" +
  "  <div class=\"input-group\">" +
  "    <div class=\"input-group-addon\">{{form.options.unit || (\'number.currency.format.unit\' | translate)}}</div>" +
  "    <input type=\"number\" class=\"form-control\" " +
  "      step=\"any\"" +
  "      sf-changed=\"form\"" +
  "      class=\"{{form.options.uiClass}}\"" +
  "      placeholder=\"{{form.placeholder}}\"" +
  "      ng-model-options=\"form.ngModelOptions\"" +
  "      ng-model=\"$$value$$\"" +
  "      schema-validate=\"form\" />" +
  "  </div>" +
  "  <span ng-if=\"form.feedback !== false\"" +
  "    class=\"form-control-feedback\"" +
  "    ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>" +
  "  <div class=\"help-block\"" +
  "    ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"" +
  "    ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>" +
  "</div>";

let templateSchemaFormPicklist = `
    <div class="form-group" ng-class="{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }" >
        <label class="control-label" ng-show="showTitle()">{{form.title}}</label>
        <picklist name="{{form.name}}" size="10" data-picklist="" data-pick-model="$$value$$" data-pick-options="o.id as o.name for o in form.schema.items"></picklist>
        <pre>{{model | json}}</pre>
    </div>
`;

  angular.module("schemaForm").run(["$templateCache", function($templateCache) {
    $templateCache.put("directives/decorators/bootstrap/array/picklist.html",templateSchemaFormPicklist);
  }]);

  angular.module('schemaForm-picklist', ['schemaForm']).config(
  ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider,  schemaFormDecoratorsProvider, sfPathProvider) {

      var picklist = function(name, schema, options) {

        console.log(name);
        console.log(schema);
        console.log(options);

        if ((schema.type == 'array') && schema.format == 'picklist') {
          var f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key  = options.path;
          f.type = 'picklist';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };

      schemaFormProvider.defaults.array.unshift(picklist);

      //Add to the bootstrap directive
      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'picklist',
        'directives/decorators/bootstrap/array/picklist.html');
      schemaFormDecoratorsProvider.createDirective('picklist',
        'directives/decorators/bootstrap/array/picklist.html');
    }]);



// WEBPACK FOOTER //
// ./client/app/schema-form.picklist.js